import { map, filter } from 'lodash';
import { createSlice } from '@reduxjs/toolkit';
import { axiosInstance as axios } from '../../utils/axios';
import { dispatch } from '../store';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  data: [],
  meta: null,
  params: {
    page: 1,
    active: true,
    deleted: false,
  },
  record: null,
};

const slice = createSlice({
  name: 'hrDepartment',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    getDepartmentsSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload.results;
      state.meta = action.payload.meta;
      state.error = false;
    },
    getDepartmentSuccess(state, action) {
      state.isLoading = false;
      state.record = action.payload;
      state.error = false;
    },
    createDepartmentSuccess(state, action) {
      state.isLoading = false;
      state.data = [...state.data, action.payload];
      state.error = false;
    },
    updateDepartmentSuccess(state, action) {
      state.record = action.payload;
      state.isLoading = false;
      state.data = map(state.data, (_record) => (_record.id === action.payload.id ? action.payload : _record));
      state.params = { ...state.params };
      state.error = false;
    },
    deleteDepartmentSuccess(state, action) {
      state.isLoading = false;
      state.data = filter(state.data, (r) => r.id !== action.payload.id);
      state.error = false;
    },
    setParams(state, action) {
      state.params = action.payload;
    },
    refreshParams(state) {
      state.params = { ...state.params };
    },
  },
});

export default slice.reducer;
export const { setParams, refreshParams } = slice.actions;

// ----------------------------------------------------------------------

export function getDepartments(params = {}) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/hr/department/', { params });
      dispatch(slice.actions.getDepartmentsSuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return error;
    }
  };
}

export function getDepartment(id) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/hr/department/${id}/`);
      dispatch(slice.actions.getDepartmentSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function createDepartment(record) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/hr/department/', record);
      dispatch(slice.actions.createDepartmentSuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

export function updateDepartment(id, record) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.put(`/hr/department/${id}/`, record);
      dispatch(slice.actions.updateDepartmentSuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

export function deleteDepartment(id, restore = false) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      await axios.delete(`/hr/department/${id}/`, { data: { restore } });
      dispatch(slice.actions.deleteDepartmentSuccess({ id }));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

export function actionDepartment(id, data) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post(`/hr/department/${id}/action/`, data);
      dispatch(slice.actions.updateDepartmentSuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

export function actionHistoryDepartment(id, data) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post(`/hr/department/${id}/history/`, data);
      dispatch(slice.actions.updateDepartmentSuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}
